import customerReducer from "./customerReducer";

export * from "./customerReducer";
export default customerReducer;
